import { ItemList } from '../../orm'
import { AnsweringMessageList } from '../../actions/answering_message'

class AdminAnsweringMessageList extends AnsweringMessageList {
    getEntityKey() {
        return "admin/answering_message"
    }
}

export const adminAnsweringVoiceMessageList = new AdminAnsweringMessageList("admin_answering_message__voice_message")
export const adminAnsweringIntroMessageList = new AdminAnsweringMessageList("admin_answering_message__intro_message")
export const adminAnsweringGoodbyeMessageList = new AdminAnsweringMessageList("admin_answering_message__goodbye_message")
